angular
    .module('app')
    .component('usersList', {
        templateUrl: '/templates/pages/users/usersList/usersList.html',
        controller: 'UsersListController',
        controllerAs: 'vm',
    });